import { apiFetch } from "./common/api";

const HOST = import.meta.env.VITE_API_HOST;

export function backendErrorLoggerFactory() {
  return (message, source, lineno, colno, error) => {
    const errorData = {
      message: message,
      source: source,
      lineno: lineno,
      colno: colno,
      error: error?.stack || String(error),
      userAgent: navigator.userAgent,
      url: window.location.href,
    };

    apiFetch(`${HOST}/api/v1/health/frontend/logs`, {
      method: "POST",
      body: JSON.stringify({ errorData }),
    }).catch(console.error);
  };
}
